const homepage = {
    title: 'Kā dzīvo studenti Latvijā?',
    starterIntro: 'EUROSTUDENT ir starptautisks zinātnisks projekts par studentu dzīves sociālajiem un ekonomiskajiem apstākļiem. Tas notiek vienlaikus lielākajā daļā Eiropas valstu.',
    starterTeaser: 'Piedalies aptaujā un laimē!',

    access: 'Ceļš uz studijām',
    accessDescription: 'Uzreiz pēc vidusskolas vai ar pārtraukumu',
    time: 'Laika sadalījums',
    timeDescription: 'Laiks lekcijām un patstavīgajam darbam',
    employment: 'Darbs',
    employmentDescription: 'Pirms, studiju laikā un pēc absolvēšanas',
    budget: 'Ienākumi un izdevumi',
    budgetDescription: 'Ko apmaksā no savas kabatas, ko palīdz segt ģimene',
    conditions: 'Dzīves apstākļi',
    conditionsDescription: 'Mājoklis, aprīkojums, ģimene',
    mobility: 'Starptautiskā mobilitāte',
    mobilityDescription: 'Pieredze apmaiņu programmās vai praksē ārzemēs',

    ctaThankYou: 'Paldies visiem, kuri piedalījās EUROSTUDENT 9 aptaujā!',
}

export default homepage
